import type { CinemaSetting, InterceptionExcludedFilm, MallJump, SeatTaskApiKey, SyncUpstreamInfo, UpdateInterceptionSeatTaskProtectionParams } from '@/types/cinemaSetting'
import type { RechargeSetting } from '@/types/rechargeSetting'
import type { Page } from '@meizhen/shared'
import { axios } from '@/api/axios'

export async function fetchSetting() {
  return axios.get<CinemaSetting>('setting').then(res => res.data)
}

export async function updateAmountLimit(params) {
  return axios.post('setting/amount_limit', params)
}

export async function updateBuyTips(params) {
  return axios.post('setting/buy_tip', params)
}

export async function updateWatchTip(params) {
  return axios.post('setting/watch_tip', params)
}

export async function fetchUpstreamInfo() {
  return axios.get<Page<SyncUpstreamInfo>>('setting/sync').then(res => res.data)
}

export async function syncUpstreamInfo() {
  return axios.post('setting/sync')
}

export async function fetchRechargeSetting() {
  return axios.get<RechargeSetting>('setting/recharge_level').then(res => res.data)
}

export async function updateRechargeSetting(params) {
  return axios.post<RechargeSetting>('setting/recharge_level', params).then(res => res.data)
}

export async function updateSeatConfirmTips(params) {
  return axios.post('setting/seat_confirm_tip', params)
}

export async function syncMemberPrice() {
  return axios.post('setting/sync/price')
}

export async function updateMemberTicketLimit(params) {
  return axios.post('setting/member_ticket_limit', params)
}

export async function updateShowMallJump(params: MallJump) {
  return axios.post('setting/show_mall', params)
}

// [ZHONGXIN-INTERCEPTION-START] 拦截配置相关 API

export async function fetchInterceptionConfig() {
  return axios.get<import('@/types/cinemaSetting').InterceptionConfig>('setting/interception').then(res => res.data)
}

export async function updateInterceptionCinemaSwitch(enabled: boolean) {
  return axios.put('setting/interception/cinema-switch', { enabled })
}

export async function updateInterceptionPhoneNumbers(phoneNumbers: string[]) {
  return axios.put('setting/interception/phone-numbers', { phoneNumbers })
}

export async function updateInterceptionTimePeriods(timePeriods: import('@/types/cinemaSetting').TimePeriod[]) {
  return axios.put('setting/interception/time-periods', { timePeriods })
}

export async function searchInterceptionExcludedFilms(keyword: string) {
  return axios.get<InterceptionExcludedFilm[]>('setting/interception/excluded-films/search', { params: { keyword } }).then(res => res.data)
}

export async function updateInterceptionExcludedFilms(films: InterceptionExcludedFilm[]) {
  return axios.put('setting/interception/excluded-films', { films })
}

export async function updateInterceptionSeatTaskProtection(params: UpdateInterceptionSeatTaskProtectionParams) {
  return axios.put('setting/interception/seat-task-protection', params)
}

export async function resetSeatTaskApiKey() {
  return axios.put<SeatTaskApiKey>('setting/interception/seat-task-api-key/reset').then(res => res.data)
}

export async function resumeInterceptionRuntime() {
  return axios.put('setting/interception/runtime/resume')
}

// [ZHONGXIN-INTERCEPTION-END]
